import React from 'react';
import { AlertCircle, X } from 'lucide-react';

const NoticeModal = ({
  open,
  title = 'Notice',
  message,
  confirmLabel = 'OK',
  cancelLabel,
  onClose,
  onConfirm,
}) => {
  if (!open || !message) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[80] p-4">
      <div className="neo-modal p-6 w-full max-w-md">
        <div className="flex items-start justify-between gap-3 mb-4">
          <div className="flex items-start gap-3">
            <AlertCircle className="w-6 h-6 text-primary-600 dark:text-primary-400 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-dark-text">{title}</h3>
              <p className="text-sm text-gray-600 dark:text-dark-muted mt-2">{message}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-dark-text"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex justify-end gap-3">
          {cancelLabel && (
            <button type="button" onClick={onClose} className="px-4 py-2 neo-btn text-gray-700 dark:text-dark-text">
              {cancelLabel}
            </button>
          )}
          <button type="button" onClick={onConfirm || onClose} className="px-4 py-2 neo-btn-primary">
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeModal;
